import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { Observable } from 'rxjs';
import {  map, tap } from 'rxjs/operators';
import { Role } from 'src/app/feature-module/portal-users/models/Role';
import { PortalUserService } from 'src/app/feature-module/portal-users/services/portalUser.service';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { FormUtilsService } from 'src/app/shared/services/form-utils.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-add-user-role',
  templateUrl: './add-user-role.component.html',
  styleUrls: ['./add-user-role.component.scss']
})
export class AddUserRoleComponent extends DialogContentBase implements OnInit {

  constructor(public dialog: DialogRef, 
    private fb: UntypedFormBuilder,
    private userService: PortalUserService, 
    private formUtilsService: FormUtilsService,
    public uiNotification: UiNotificationService,
    private translateService: TranslateService
    ) {
    super(dialog);
  }

  ngOnInit(): void {
    this.initForm();
  }

  rolesList$: Observable<Role[]>;
  @Input() public excludeRoles: number[];
  @Input() public userId: string;

  assignRoleForm: UntypedFormGroup;

  initForm(): void {

    this.assignRoleForm = this.fb.group(
      {
        roleId: [0, [Validators.required]]
      });

    this.rolesList$ = this.userService.getAllRoles().pipe(
      map(x => x.filter(r => !this.excludeRoles.includes(r.id))),
      tap(x => x.forEach(r => r.description = this.translateService.instant(r.description)))
    );
  }


  cancel() {
    this.dialog.close({ text: 'Cancel' });
  }

  confirm() {

    if (!this.formUtilsService.markFormGroupTouched(this.assignRoleForm)) {
      this.uiNotification.showValidationError();
      return;
    }

    const roleId = this.assignRoleForm.value.roleId;

    this.userService.addUserRole(this.userId, roleId).subscribe(
      r => {
        this.uiNotification.showSuccess('validations.userRolesUpdated');
        this.dialog.close({ text: 'OK' });
      });
  }
}
